import {
  AuthSession,
  CurrentUser,
  WalletModel,
} from '@fantaz/shared/data-access/models';
import { Action, createReducer, on } from '@ngrx/store';
import { merge } from 'lodash';
import {
  AuthActions,
  AuthCurrentUserActions,
  AuthSessionActions,
  loadWalletFailure,
  loadWalletSuccess,
  updateUserLocally,
} from './auth.actions';

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthState {
  isAuthenticated?: boolean;
  currentUser?: CurrentUser; // which Auth record has been selected
  wallet?: WalletModel | null;
  session?: AuthSession;
  loaded: boolean; // has the Auth list been loaded
  loading: boolean; // has the Auth list been loaded
  error?: string | null; // last known error (if any)
  message?: string | null; // last message (if any)
  changingPassword?: boolean | null; // last message (if any)
}

export const initialState: AuthState = {
  loaded: false,
  loading: false,
  error: null,
  message: null,
};

const authReducer = createReducer(
  initialState,
  on(AuthActions.loadAuthSession, (state) => ({
    ...state,
    isAuthenticated: true,
  })),
  on(AuthSessionActions.loadAuthSessionSuccess, (state, { session }) => ({
    ...state,
    session,
  })),
  on(
    AuthCurrentUserActions.loadCurrentUserSuccess,
    (state, { currentUser }) => ({
      ...state,
      loaded: true,
      loading: false,
      currentUser: {
        ...currentUser,
      },
    }),
  ),

  on(loadWalletSuccess, (state, { wallet }) => ({
    ...state,
    wallet,
    error: null,
  })),

  on(loadWalletFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // old
  /*
   * Updates the user locally, using deep merge to ensure that the user object
   * is not replaced, but rather updated with the new values.
   */
  on(updateUserLocally, (state, { user }) => ({
    ...state,
    ...merge({}, state, {
      currentUser: { user },
    }),
  })),
);

export function sharedAuthReducer(
  state: AuthState | undefined,
  action: Action,
) {
  return authReducer(state, action);
}
